export const en = {
	navbarMenu: {
		dashboard: "Dashboard",
		properties: "Properties",
		outstanding: "Outstanding",
		documents: "Documents",
		utilities: "Utilities",
		financialStatus: "Financial Status",
		statements: "Statements",
		notifications: "Notifications",
		tickets: "Tickets",
		securityDeposits: "Security Deposits",
		profile: "Profile",
		subscription: "Subscription",
		payments: "Payments",
		messages: "Messages",
		customOwnerPlans: "Service Packages",
		financialStatements: "Financial Statements",
	},
	types: {
		tax: "Tax",
		centralHeatingVerification: "Central Heating Verification",
		insurance: "Insurance",
		rent: "Rent",
		other: "Other",
		administrationContract: "Administration Contract",
		gasContract: "Gas Contract",
		electricityContract: "Electricity Contract",
		waterContract: "Water Contract",
		optionalInsurance: "Optional Insurance",
		gasVerification: "Gas Verification",
		gasRevision: "Gas Revision",
		lastGasInvoice: "Last Gas Invoice",
		lastElectricityInvoice: "Last Electricity Invoice",
		lastWaterInvoice: "Last Water Invoice",
		tenantAssociationCertificate: "Tenant Association Certificate",
		sanitationDeclaration: "Sanitation Declaration",
		aquisitionAct: "Acquisition Act",
		entryReport: "Entry Report",
		exitReport: "Exit Report",
		observationReport: "Observation Report",
		formerTenant: "Former Tenant",
		ownerSpouse: "Owner Spouse",
		buildingSuper: "Building Superintendent",
		headOfTenantAssociation: "Head of Tenant Association",
		cityHall: "City Hall",
		finances: "Finances",
		water: "Water",
		gas: "Gas",
		electricity: "Electricity",
		internet: "Internet",
		gasUtility: "Gas",
		electricityUtility: "Electricity",
		waterUtility: "Water",
		internetUtility: "Internet",
		sanitationUtility: "Sanitation",
		cleaningUtility: "Cleaning",
		administrationFee: "Administration Fee",
		protocol: "Protocol",
		lease: "Lease",
		custodyCash: "Cash Custody",
		custodyBank: "Bank Custody",
		total: "Total",
		owner: "Owner",
		returned: "Returned",
		returnedTenant: "Returned to Tenant",
		extension: "Extension",
		termination: "Termination",
		rentModification: "Rent Modification",
		c168: "C168 Declaration",
		pending: "Pending",
		done: "Done",
		new: "New",
		gasAccount: "Gas Account",
		electricityAccount: "Electricity Account",
		waterAssociation: "Water Association",
		ownerIdentificationDocument: "Owner ID",
		tenantAssociationAnnouncement: "Tenant Association Announcement",
		tenants: "Tenants",
		jobCertificate: "Job Certificate",
		meterPictures: "Meter Pictures",
	},
	dashboard: {
		expiringLeases: "Expiring Leases",
		expiringDocuments: "Expiring Documents",
		revenue: "Revenue",
		properties: "Properties",
		securityDeposits: "Security Deposits",
		monthlyRevenue: "Monthly Revenue",
		administrationFee: "Administration Fee",
		openTickets: "Open Tickets",
		occupied: "Occupied",
		empty: "Empty",
	},
	table: {
		date: "Date",
		recipients: "Recipients",
		addedDate: "Added Date",
		issuedDate: "Issued Date",
		dueDate: "Due Date",
		paidDate: "Paid Date",
		method: "Method",
		type: "Type",
		owner: "Owner",
		address: "Address",
		status: "Status",
		title: "Title",
		author: "Author",
		endDate: "End Date",
		amount: "Amount",
		tenant: "Tenant",
		currency: "Currency",
		view: "View",
		delete: "Delete",
		noData: "No data to display",
		previousMonth: "Previous Month",
		nextMonth: "Next Month",
		rent: "Rent",
		tenants: "Tenants",
		lease: "Lease",
		statements: "Statements",
		administration: "Administration",
		incomplete: "Incomplete",
		complete: "Complete",
		warning: "Warning",
		empty: "Empty",
		expired: "Expired",
		last10Activities: "Last 10 Activities",
		markAsPaid: "Mark as Paid",
		name: "Name",
		number: "Number",
		startingDate: "Starting Date",
		signatureDate: "Signature Date",
		expirationDate: "Expiration Date",
		actions: "Actions",
		download: "Download",
		markAsActive: "Mark as Active",
		markAsInactive: "Mark as Inactive",
		due: "Due",
		overDue: "Overdue",
		paid: "Paid",
		rentReceived: "Rent Received",
		administrationFee: "Administration Fee",
		tax: "Tax",
		centralHeating: "Central Heating",
		insurance: "Insurance",
		others: "Others",
		subTotal: "Subtotal",
		year: "Year",
		nextYear: "Next Year",
		previousYear: "Previous Year",
		description: "Description",
		location: "Location",
		custodian: "Custodian",
		updatedDate: "Updated Date",
		lastActivities: "Last Activities",
		statement: "Statement",
		c168: "C168",
		lastMessage: "Last Message",
		price: "Price",
		page: "Page",
		of: "of",
		viewDetails: "View Details",
	},
	properties: {
		properties: "Properties",
		addProperty: "Add Property",
		archivedProperties: "Archived Properties",
		location: "Location",
		keys: "Keys",
		agent: "Agent",
		bankDetails: "Bank Details",
		owner: "Owner",
		street: "Street",
		buildingNumber: "Building Number",
		blockNumber: "Block Number",
		apartmentNumber: "Apartment Number",
		entrance: "Entrance",
		area: "Area",
		city: "City",
		county: "County",
		IBAN: "IBAN",
		administrationFeePercentage: "Administration Fee Percentage",
		currency: "Currency",
		name: "Name",
		email: "Email",
		phoneNumber: "Phone Number",
		verifyEmail: "Important: Verify email address carefully; cannot be changed later.",
		total: "Total",
		occupied: "Occupied",
		empty: "Empty",
		iban: "IBAN",
		administrationFeePercent: "Administration Fee Percentage",
		searchAddress: "Search by address",
		searchOwner: "Search by owner",
		searchTenant: "Search by tenant",
		searchFormerTenant: "Search by former tenant",
		searchContact: "Search by contact",
		searchGasPayment: "Search by gas payment code",
		searchGasClient: "Search by gas client code",
		searchWaterNLC: "Search by water NLC code",
		searchWaterATM: "Search by water ATM code",
		searchAdminStatus: "Search by administration status",
		searchLeaseStatus: "Search by lease status",
		searchStatementStatus: "Search by statement status",
		searchAssociation: "Search by association",
		searchAssociationAdmin: "Search by association administrator",
		searchAssociationEmail: "Search by association email",
		uploadContract: "Upload Contract",
		smartContract: "Smart Contract",
		uploadDescription: "Upload a PDF or Word document",
		enterCustomAmount: "Enter a custom amount",
		confirm: "Confirm",
		addRentPayment: "Add a Rent Payment",
		rentPaymentDisclaimer: "By issuing a rent payment manually, another one will not be issued this month automatically by the system.",
		addAdministrationFeePayment: "Add Administration Fee Payment",
		admFeePaymentDescription:
			"Add an invoice for the standard administration fee, or with a custom value. You can include or exclude service packages by checking the corresponding boxes.",
		alreadyPaid: "Already paid?",
		customValue: "Custom value?",
		enterValue: "Enter value",
		selectServices: "Select which services to include in this payment",
		editMonthlyServices: "Edit Monthly Service Package",
		monthlyServicesDescription:
			"Select the desired service package for this property. These will be automatically added to the monthly administration fee value.",
		estimatedTotal: "Estimated total",
		perMonth: "per month",
	},
	outstanding: {
		outstanding: "Outstanding",
		missingRentPayment: "Missing Rent Payment",
		noOutstandingPayments: "No Outstanding Payments",
	},
	utilities: {
		utilities: "Utilities",
		gas: "Gas",
		water: "Water",
		electricity: "Electricity",
		sanitation: "Sanitation",
		internet: "Internet",
	},

	documents: {
		documents: "Documents",
		exportAsCsv: "Export as CSV",
		type: "Type",
	},

	financialStatus: {
		financialStatus: "Financial Status",
		monthlyTotals: "Monthly Totals",
		rentReceivedAndTransferred: "Rent Received and Transferred",
		rentReceivedNotTransferred: "Rent Received Not Transferred",
		rentNotReceived: "Rent Not Received",
		custodie: "Custody",
		transferat: "Transferred",
		ownerAccount: "Owner Account",
		predareCash: "Delivery Cash",
		exportFinancialStatus: "Export Financial Status",
	},
	statements: {
		statements: "Statements",
	},

	tickets: {
		tickets: "Tickets",
	},

	securityDeposits: {
		securityDeposits: "Security Deposits",
		totals: "Totals",
		custodyCash: "Custody Cash",
		custodyBank: "Custody Bank",
		owner: "Owner",
		total: "Total",
		returned: "Returned",
		returnedTenant: "Returned to Tenant",
	},
	property: {
		propertyDetails: "Property Details",
		archive: "Archive",
		restore: "Restore",
		general: "General",
		specs: "Specifications",
		images: "Images",
		contacts: "Contacts",
		utilities: "Utilities",
		payments: "Payments",
		securityDeposits: "Security Deposits",
		financialStatements: "Financial Statements",
		documents: "Documents",
		accounts: "Accounts",
		activities: "Activities",
		tenants: "Tenants",
		notifications: "Notifications",
		tickets: "Tickets",
		messages: "Messages",
		location: "Location",
		county: "County",
		city: "City",
		area: "Area",
		street: "Street",
		buildingNumber: "Building Number",
		blockNumber: "Block Number",
		apartmentNumber: "Apartment Number",
		entrance: "Entrance",
		keys: "Keys",
		description: "Description",
		bankAccount: "Bank Account",
		bankAccountCurrency: "Bank Account Currency",
		administrationFeePercentage: "Administration Fee Percentage",
		administration: "Administration",
		lease: "Lease",
		financial: "Financial",
		rentPrice: "Rent Price",
		rentCollection: "Rent Collection Period",
		rentExchangeRate: "Rent Exchange Rate",
		fixedAdministrationFee: "Fixed Administration Fee",
		agent: "Agent",
		dateAdded: "Date Added",
		editRent: "Edit Rent",
		editRentSubtitle: "Update rent amount, payment schedule, and exchange rate settings",
		rentPaymentInterval: "Rent Payment Interval",
		selectCurrency: "Select Currency",
		enterAmount: "Enter Amount",
		addMedia: "Add Media",
		contactInformation: "Contact Information",
		addContact: "Add Contact",
		addAssociation: "Add Association",
		association: "Association",
		editAssociation: "Edit Association",
		removeAssociation: "Remove Association",
		name: "Name",
		email: "Email",
		phoneNumber: "Phone Number",
		phoneNumber2: "Secondary Phone Number",
		administratorName: "Administrator Name",
		iban: "IBAN",
		index: "Index",
		additionalIndex: "Additional Index",
		addIndex: "Add Index",
		addUtilityInvoice: "Add Utility Invoice",
		gas: "Gas",
		electricity: "Electricity",
		water: "Water",
		sanitation: "Sanitation",
		internet: "Internet",
		history: "History",
		requestMeterPicture: "Request Meter Picture",
		gasIndex: "Gas",
		electricityIndex: "Electricity",
		waterIndex: "Water",
		utilityPayments: "Utility Payments",
		markMultipleAsPaid: "Mark Multiple as Paid",
		totalDue: "Total Due",
		totalOverdue: "Total Overdue",
		requestPeriod: "Request Period",
		collectionCode: "Collection Code",
		clientCode: "Client Code",
		nlcCode: "NLC Code",
		atmCode: "ATM Code",
		addPayment: "Add Payment",
		addRentPayment: "Add Rent Payment",
		addAdministrationFeePayment: "Add Administration Fee Payment",
		editCustomOwnerPlanList: "Edit service packages",
		paymentDate: "Payment Date",
		paymentDirection: "Payment Direction",
		documentNumber: "Document Number",
		method: "Method",
		amount: "Amount",
		currency: "Currency",
		type: "Type",
		billedTo: "Billed To",
		billedToName: "Billed To Name",
		billedToType: "Billed To Type",
		addSecurityDeposit: "Add Security Deposit",
		addFinancialStatement: "Add Financial Statement",
		addFinancialStatementSubtitle: "Add a financial statement or C168 declaration for this property",
		financialStatementInformation: "Statement Information",
		financialStatementDetailsTitle: "Financial Statement Details",
		viewFinancialStatementSubtitle: "View statement information and documents",
		statementSummary: "Statement Summary",
		deleteFinancialStatementConfirmation: "Are you sure you want to delete this financial statement?",
		addTicketSubtitle: "Create a new support ticket for this property",
		ticketInformation: "Ticket Information",
		ticketDetailsTitle: "Ticket Details",
		viewTicketSubtitle: "View and manage ticket information",
		ticketSummary: "Ticket Summary",
		ticketConversation: "Conversation",
		noRepliesYet: "No replies yet",
		yourResponse: "Your Response",
		typeYourMessage: "Type your message here...",
		markAsDone: "Mark as Done",
		deleteTicketConfirmation: "Are you sure you want to delete this ticket?",
		uploadImageOrVideo: "Upload an image or a video",
		titlePlaceholder: "Enter title",
		emitNotificationSubtitle: "Send a notification to property tenants",
		notificationInformation: "Notification Information",
		enterNotificationTitle: "Enter notification title",
		enterNotificationMessage: "Enter your message here...",
		sendMessageSubtitle: "Send a message to the owner or tenant",
		messageInformation: "Message Information",
		messageDetailsTitle: "Message Details",
		viewMessageSubtitle: "View and respond to message",
		messageReplies: "Replies",
		addReply: "Add Reply",
		addAssociationSubtitle: "Link an association to this property",
		editAssociationSubtitle: "Update association information for this property",
		associationInformation: "Association Information",
		associationSource: "Association Source",
		ownerHandlesFinancials: "Owner Handles Financials",
		addDocument: "Add Document",
		addProtocol: "Add Protocol",
		tenantAssociationNotification: "Tenant Association Notification",
		protocols: "Protocols",
		addAccount: "Add Account",
		accountInformation: "Account Information",
		provider: "Provider",
		userName: "User Name",
		password: "Password",
		addActivity: "Add Activity",
		enterTitle: "Enter activity title...",
		enterDescription: "Enter activity description...",
		selectType: "Select activity type",
		addLease: "Add Lease Agreement",
		addAdditionalDocument: "Add Additional Document",
		addTenant: "Add Tenant",
		addReport: "Add Report",
		ownerHandlesSanitationDeclaration: "Owner Handles Sanitation Declaration",
		formerTenants: "Former Tenants",
		markFormer: "Mark as Former Tenant",
		markActive: "Mark as Active Tenant",
		formerContacts: "Former Contacts",
		reports: "Reports",
		sendNotification: "Send Notification",
		systemNotifications: "System Notifications",
		noNotifications: "No Notifications",
		notificationsWillAppearHere: "Your notifications will appear here",
		noSystemNotifications: "No System Notifications",
		systemNotificationsWillAppearHere: "System notifications will appear here",
		emitNotification: "Emit Notification",
		notificationTitle: "Notification Title",
		notificationMessage: "Message",
		notifyOwner: "Notify Owner",
		addTenantsToEnable: "Add tenants to enable notifications",
		message: "Message",
		addTicket: "Add Ticket",
		sendMessage: "Send Message",
		showPassword: "Show Password",
		hidePassword: "Hide Password",
		enterPassword: "Enter password",
		selectAccountType: "Select account type",
		enterProvider: "Enter provider",
		enterUsername: "Enter username",
		accountType: "Account Type",
		contactList: "Contact List",
		namePlaceholder: "Enter name",
		emailPlaceholder: "Enter email address",
		phoneNumberPlaceholder: "Enter phone number",
		alternativePhone: "Alternative Phone Number",
		selectContactType: "Select contact type",
		existingAssociation: "Existing Association",
		newAssociation: "New Association",
		associationNamePlaceholder: "Enter association name",
		administratorNamePlaceholder: "Enter administrator name",
		ibanPlaceholder: "Enter IBAN",
		descriptionPlaceholder: "Enter description",
		selectAssociation: "Select Association",
		selectAssociationPlaceholder: "Choose an association",
		confirmDelete: "Confirm Delete",
		deleteAssociationConfirmation: "Are you sure you want to remove the association from this property?",
		actionCannotBeUndone: "This action cannot be undone!",
		securityDepositDetails: "Security Deposit Details",
		addSecurityDepositSubtitle: "Add a new security deposit for this property",
		depositInformation: "Deposit Information",
		updateSecurityDepositSubtitle: "Update security deposit information",
		depositSummary: "Deposit Summary",
		currentLocation: "Current Location",
		updateInformation: "Update Information",
		notSpecified: "Not specified",
		deleteSecurityDepositConfirmation: "Are you sure you want to delete this security deposit?",
		documentNumberLabel: "Document Number",
		documentNumberPlaceholder: "Enter document number",
		locationLabel: "Location",
		amountLabel: "Amount",
		amountPlaceholder: "Enter amount",
		currencyLabel: "Currency",
		currencyPlaceholder: "Select currency",
		custodianLabel: "Custodian",
		custodianPlaceholder: "Enter custodian name",
		descriptionLabel: "Description",
		documentsLabel: "Documents",
		uploadDocuments: "Upload Documents",
		uploadDocumentsDescription: "Upload PDF, DOC or DOCX Format",
		invalidInformation: "Invalid information provided",
		securityDepositAdded: "Security Deposit added successfully",
		financialStatementAdded: "Financial Statement added successfully",
		notAvailable: "N/A",
		firstDay: "First Day",
		lastDay: "Last Day",
		contactType: "Contact Type",
		fixedExchangeRate: "Fixed Exchange Rate",
		enterExchangeRate: "Enter exchange rate",
		noAssociationMessage: "No association has been added to this property",
		addPaymentSubtitle: "Add a new payment to this property",
		addRentPaymentSubtitle: "Add rent payment for this property",
		addAdmFeePaymentSubtitle: "Add administration fee payment",
		editMonthlyServicesSubtitle: "Configure monthly services for this property",
		completePaymentInfo: "Complete payment information",
		paymentSummary: "Payment Summary",
		paymentDetails: "Payment Details",
		paymentDetailsTitle: "Payment Details",
		viewPaymentSubtitle: "View payment information and documents",
		billingInformation: "Billing Information",
		billingDetails: "Billing Details",
		paymentInformation: "Payment Information",
		supportingDocuments: "Supporting Documents",
		paymentTimeline: "Payment Timeline",
		existingDocuments: "Existing Documents",
		addNewDocument: "Add New Document",
		noDocumentsAttached: "No documents attached",
		clickToDownload: "Click to download",
		documentReady: "Document Ready",
		documentReadyDescription: "{{name}} is ready to be uploaded",
		deletePaymentConfirmation: "Are you sure you want to delete this payment?",
		currencyExchange: "Currency Exchange",
		billedInDifferentCurrency: "Billed in different currency",
		exchangeRateInfo: "Exchange Rate Information",
		equivalentAmount: "Equivalent Amount",
		notPaidYet: "Not paid yet",
		issueDate: "Issue Date",
		paymentAmount: "Payment Amount",
		feeConfiguration: "Fee Configuration",
		selectAmountType: "Select Amount Type",
		currentRentAmount: "Current Rent Amount",
		customAmount: "Custom Amount",
		enterDifferentAmount: "Enter a different amount",
		currentAdministrationFee: "Current Administration Fee",
		availableServices: "Available Services",
		monthlyServices: "Monthly Services",
		estimatedTotal: "Estimated Total",
		perMonth: "per month",
		selectRecipient: "Select recipient",
		uploadPdfDocDocx: "Upload PDF, DOC or DOCX files",
		addDocumentSubtitle: "Add a property document with dates and file upload",
		addProtocolSubtitle: "Add a protocol document with optional media",
		documentInformation: "Document Information",
		protocolDetailsTitle: "Protocol Details",
		viewProtocolSubtitle: "View protocol information and media",
		protocolSummary: "Protocol Summary",
		protocolDocument: "Protocol Document",
		mediaGallery: "Media Gallery",
		noMediaAttached: "No media attached",
		isActiveDocument: "Is Active?",
		uploadMediaDescription: "Upload an image or a video",
		markMultipleAsPaidSubtitle: "Mark multiple utility payments as paid simultaneously",
		selectPayments: "Select Payments",
		addUtilityInvoiceSubtitle: "Add a new utility invoice to this property",
		utilityInvoiceAlertTitle: "Utility Invoice",
		utilityInvoiceAlertDescription: "Add utility bills for electricity, gas, water, or other services",
		invoiceDetails: "Invoice Details",
		invoiceDocument: "Invoice Document",
		utilityType: "Utility Type",
		selectUtilityType: "Select utility type",
		historySubtitle: "View meter readings and utility history",
		gasMeterHistory: "Gas Meter History",
		electricityMeterHistory: "Electricity Meter History",
		waterMeterHistory: "Water Meter History",
		noMeterPicturesYet: "No meter pictures yet.",
		requestMeterPictureSubtitle: "Request meter pictures from tenants",
		meterPictureRequestTitle: "Meter Picture Request",
		meterPictureRequestDescription: "Select which meter pictures you want to request from the tenants",
		selectMeters: "Select Meters",
		waterMeter: "Water Meter",
		electricityMeter: "Electricity Meter",
		gasMeter: "Gas Meter",
		requestWaterMeterReading: "Request current water meter reading",
		requestElectricityMeterReading: "Request current electricity meter reading",
		requestGasMeterReading: "Request current gas meter reading",
		addIndexSubtitle: "Add a new meter reading for this property",
		meterReadingTitle: "Meter Reading",
		meterReadingDescription: "Record the current meter index for electricity, gas, or water",
		meterInformation: "Meter Information",
		meterType: "Meter Type",
		selectMeterType: "Select meter type",
		newIndex: "New Index",
		enterIndexValue: "Enter index value",
		additionalIndexOptional: "Additional Index (optional)",
		enterAdditionalIndex: "Enter additional index",
		editMeterTitle: "Edit {{type}} Meter",
		editMeterSubtitle: "Update meter configuration and settings",
		meterCodes: "Meter Codes",
		paymentCode: "Payment Code",
		collectionPeriod: "Collection Period",
		collectionPeriodHint: "Enter a day between 1 and 31 for the collection period",
		cleaning: "Cleaning",
		addAdditionalDocumentSubtitle: "Add a new additional document to this property",
		documentUpload: "Document Upload",
		documentStatus: "Status",
		addTenantSubtitle: "Add a new tenant or select an existing one",
		tenantType: "Tenant Type",
		newTenant: "New Tenant",
		existingTenant: "Existing Tenant",
		selectExistingTenant: "Select Existing Tenant",
		searchSelectTenant: "Search and Select Tenant",
		searchExistingTenantsPlaceholder: "Search for existing tenants...",
		noTenantsFound: "No tenants found",
		loadingTenants: "Loading tenants...",
		selectedTenant: "Selected Tenant",
		newTenantInformation: "New Tenant Information",
		fullName: "Full Name",
		emailAddress: "Email Address",
		addSelectedTenant: "Add Selected Tenant",
		addNewTenant: "Add New Tenant",
		addContactSubtitle: "Add a new contact to this property",
		contactDetails: "Contact Details",
		contactInformationAlert: "Add contact details for property-related communications and management.",
		addLeaseSubtitle: "Add a new lease agreement to this property",
		financialInformation: "Financial Information",
		exchangeRateConfiguration: "Exchange Rate Configuration",
		administrationFeeOptional: "Administration Fee (Optional)",
		leaseDocument: "Lease Document",
		firstRentDay: "First Rent Day",
		lastRentDay: "Last Rent Day",
		addReportSubtitle: "Add a new report to this property",
		reportInformation: "Report Information",
		reportDocument: "Report Document",
		mediaFiles: "Media Files",
		uploadImagesOrVideos: "Upload Images or Videos",
		rentRevenueSummaryTitle: "Rent Revenue Summary",
		rentRevenueSummarySubtitle: "Generated revenue for this lease period",
		leasePeriod: "Lease Period",
		startDate: "Start Date",
		endDate: "End Date",
		generatedRevenue: "Generated Revenue",
		eurRevenue: "EUR Revenue",
		ronRevenue: "RON Revenue",
		totalRevenue: "Total Revenue",
		reportDetailsTitle: "Report Details",
		viewReportSubtitle: "View report information and media",
		reportSummary: "Report Summary",
		activeLabel: "Active",
		inactiveLabel: "Inactive",
	},

	misc: {
		loading: "Loading...",
		search: "Search...",
		legend: "Legend",
		cancel: "Cancel",
		close: "Close",
		save: "Save",
		edit: "Edit",
		send: "Send",
		add: "Add",
		delete: "Delete",
		request: "Request",
		showPassword: "Show Password",
		hidePassword: "Hide Password",
	},
	notifications: {
		sendNotification: "Send Notification",
		title: "Title",
		enterTitle: "Enter notification title",
		message: "Message",
		enterMessage: "Enter your message here...",
		recipientType: "Recipient Type",
		singleProperty: "Single Property",
		multipleUsers: "Multiple Users",
		selectProperty: "Select Property",
		chooseProperty: "Choose a property",
		includeOwner: "Include Property Owner",
		allOwners: "All Property Owners",
		allTenants: "All Tenants",
		send: "Send Notification",
		propertyNotifications: "Property Notifications",
		massNotifications: "Mass Notifications",
		notifications: "Notifications",
		noPropertyNotifications: "No property notifications sent yet.",
		noMassNotifications: "No mass notifications sent yet.",
		massNotification: "Mass Notification",
		propertyNotification: "Property Notification",
		recipients: "Recipients",
		sent: "Sent",
		showMore: "Show More",
		copyAllEmails: "Copy All Emails",
		emailsCopied: "Emails copied to clipboard",
		searchRecipients: "Search recipients",
	},
	activityTypes: {
		insurance: "Insurance",
		administrationContract: "Administration Contract",
		lease: "Lease",
		email: "Email",
		whatsapp: "WhatsApp",
		conversation: "Conversation",
		other: "Other",
	},
	financialStatements: {
		title: "Financial Statements",
		description: "View and download financial statements for your properties",
		noStatements: "No financial statements available for the selected year",
	},
};
